import React from 'react';
import './style.scss';
import { GradientIcon, DefaultIcon } from '../../../atoms/icons/index';

interface Props {
    icon: React.ReactElement<DefaultIcon> | React.ReactElement<GradientIcon>;
    title: string;
    show: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement>
}

const Title: React.FC<Props> = (props) => {
  const {
    icon, title, show, onClick,
  } = props;

  return (
    <button
      type="button"
      className="navTitle"
      onClick={onClick}
    >
      <div className="icon">
        {icon}
      </div>
      <div className={`title ${!show ? 'd-none' : ''}`}>{title}</div>
    </button>
  );
};

export default Title;
